<template>
    <div class="image-management-container">
        <div class="row">
            <div class="upload-box">
                <el-upload class="upload-demo" drag :action="action" :show-file-list="false" :on-change="handChange"
                    :headers="customHeaders" :before-upload="handleBeforeUpload" multiple
                    accept="image/png,image/jpg,image/jpeg">
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    <!-- <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div> -->
                </el-upload>
            </div>
            <div class="btn-box">
                <div class="search-box">
                    <span>图片名称：</span>
                    <el-input v-model="searchString" clearable/>
                    <el-button type="primary" @click="search">搜索</el-button>
                </div>
                <el-button type="primary" @click="copyMore">批量复制</el-button>
            </div>
        </div>
        
        <el-table :data="imgList" border max-height="600px" v-loading="isLoading" ref="multipleTable">
            <el-table-column type="selection" width="55" align="center">
            </el-table-column>
            <el-table-column label="名称" prop="imageName" width="300" align="center">
            </el-table-column>
            <el-table-column label="图片" width="200" align="center">
                <template slot-scope="scope">
                    <img :src="scope.row.imageUrl" width="100" align="center">
                </template>
            </el-table-column>
            <el-table-column label="图片地址" prop="imageUrl" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.imageUrl }}</span>
                    <el-tooltip class="item" effect="dark" content="复制" placement="top">
                        <el-button type="text" icon="el-icon-copy-document" style="padding:0;margin-left: 10px;"
                            @click="myCopyText(scope.row.imageUrl)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="100" align="center">
                <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="delImg(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        
        <div class="el-pagination-block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 500]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="imgTotal">
            </el-pagination>
        </div>

    </div>
</template>
<script>
import { ajaxPost, Baseurl } from '../../../api/api/api'
import {copyText} from '../../../utils/common';
import { mapState } from 'vuex';
import Axios from "axios";
export default {
    name: "imageManagement",
    data() {
        return {
            action: Baseurl + 'imageController/uploadImageToPool',
            customHeaders: { token: localStorage.getItem('token') },
            imgListUpdate:[],
            imgList: [],
            page: 1,
            size: 10,
            imgTotalNum: 0,
            imgSuccNum: 0,
            imgTotal: 0,
            isLoading: false,
            debounceTimer: null,
            searchString: '',
        };
    },
    computed:{
        ...mapState({
            role: state => state.user.role,
        })
    },
    watch: {
        imgSuccNum(){
            console.log(this.imgSuccNum, this.imgTotalNum);
            if(this.imgTotalNum !== 0){
                if(this.imgSuccNum === this.imgTotalNum){
                    this.$message.success('上传成功！');
                    this.getPageData();
                }
            }
        }
    },
    
    mounted() {
        this.getPageData();
    },
    methods: {
        copyMore(){
            const data = this.$refs.multipleTable.selection;
            if(data.length === 0){
                this.$message.error('请选择要复制的图片！')
                return
            }
            this.myCopyText(data.map(item => item.imageUrl).join('\n'))
        },
        delImg(row){
            this.$confirm('确定删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    idList: [row.id]
                }
                ajaxPost(Baseurl + 'orderImageUrlController/deleteOrderImageUrl', params).then((res) => {
                    if (res.data && res.data.code === 200) {
                        this.$message.success('删除成功');
                        this.getPageData();
                    }
                })
            }).catch(() => {
                
            });
            
        },
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.getPageData();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getPageData();
        },
        search(){
            this.page = 1;
            this.size = 10;
            this.getPageData();
        },
        getPageData(){
            this.isLoading = true;
            const params = {
                companyId: this.role.company_id,
                page: this.page,
                size: this.size,
            }
            if (this.searchString){
                params['searchString'] = this.searchString;
            }
            ajaxPost(Baseurl + 'orderImageUrlController/getOrderImageUrlTools', params).then((res)=>{
                if(res.data && res.data.code === 200){
                    this.imgList = res.data.data.list;
                    this.imgTotal = res.data.data.total;
                    this.isLoading = false;
                }
            })
        },
        myCopyText(text){
            copyText(text).then(() => {
                this.$message.success('复制成功')
            }).catch(() => {
                this.$message.error('复制失败')
            })
        },
        handleBeforeUpload(file){
            const formData = new FormData();
            formData.append("file", file);
            formData.append("companyId", this.role.company_id);
            Axios({
                url: Baseurl + 'imageController/uploadImageToPool',
                method: "post",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data",
                    "token": localStorage.getItem('token')
                },
            }).then((res) => {
                if (res.status === 200 && res.data.code === 200){
                    this.getPageData();
                    // this.imgSuccNum ++;
                }else{
                    // this.imgSuccNum ++;
                    this.$message.error("上传失败！");
                }
            })
            return false
        },
		handChange(file, fileList) {
            // this.isLoading = true;
            this.imgTotalNum = fileList.length;
            this.imgSuccNum = 0;
		},
    },
};
</script>
<style scoped lang="scss">
.row{
    display: flex;
    margin-bottom: 10px;
    .btn-box{
        flex: 1;
        display: flex;
        // flex-direction: column;
        align-items: center;
        justify-content: center;
        .search-box{
            margin-right: 20px;
            display: flex;
            align-items: center;
            span{
                white-space: nowrap;
                font-size: 16px;
            }
            .el-input{
                margin-right: 10px;
                width: 300px;
            }
        }
    }
}
.upload-box{
    height: 100px;
    width: 400px;
    margin-bottom: 10px;
    /deep/ .el-upload{
        height: calc(100%);
        width: 100%;
    }
    .upload-demo{
        height: 100%;
        width: 100%;
        .el-upload__tip{
            margin-top: 10px; 
        }
    }
    /deep/ .el-upload-dragger{
        height: 100%;
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .el-icon-upload{
            margin: 0;
        }
    }
}
/deep/ .el-table .cell img{
    width: 100px;
    height: 100px;
    border: 1px solid #eee;
    object-fit: contain;

}
.el-pagination-block{
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
